// What a 401 does after auth is cleared — router.tsx registers the redirect to /login.
// The API layer never imports the router: it imports every page, so @/services and
// every hook barrel would load the whole UI (rule in .eslintrc.cjs). No imports here,
// so registering is safe in any import order.
let onUnauthorized: () => void = () => {};

export const setUnauthorizedHandler = (handler: () => void): void => {
  onUnauthorized = handler;
};

export const notifyUnauthorized = (): void => {
  onUnauthorized();
};
